(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/match-info-components/assets/javascripts/over-under.js') >= 0) return;  svs.modules.push('/components/sportinfo/match-info-components/assets/javascripts/over-under.js');
"use strict";


const {
  useSelector
} = ReactRedux;
const {
  selectEventStatisticCurrentValueByType
} = svs.components.sportinfo.matchInfoRedux.selectors;
const {
  TableComponent
} = svs.components.sportinfo.matchInfoComponents;
const {
  EventTypeId,
  EventTypeField
} = svs.components.sportinfo.common.constants;
const {
  createEventStatisticsKey
} = svs.components.sportinfo.common.helpers;
const {
  getOutcomeLabelsForEventType,
  getOutcomeCount
} = svs.components.sport.tipsenShared;
const {
  SportTypes
} = svs.components.sport.sportTypes;
const {
  Odds: formatOdds
} = svs.utils.format;
const OverUnder = _ref => {
  let {
    betEvent,
    matchId,
    branding
  } = _ref;
  const eventTypeId = EventTypeId.OVER_UNDER;
  const sportType = SportTypes.Soccer;
  const eventStatisticsKey = createEventStatisticsKey({
    matchId,
    eventTypeId,
    periodNumber: betEvent.periodNumber,
    eventNumber: betEvent.eventNumber
  });
  let odds = useSelector(state => selectEventStatisticCurrentValueByType(state, eventStatisticsKey, EventTypeField.Odds));
  if (odds.length === 0) {
    odds = new Array(getOutcomeCount(EventTypeId.OVER_UNDER)).fill(null);
  }
  const outcomeLabels = getOutcomeLabelsForEventType(eventTypeId, sportType);
  return React.createElement(TableComponent, {
    ariaDescription: "Spelf\xF6rdelning f\xF6r totalt antal m\xE5l p\xE5 matchen",
    branding: branding,
    className: "match-info-over-under-odds"
  }, React.createElement(TableComponent.Header, {
    branding: branding,
    className: "match-info-over-under-odds-row"
  }, React.createElement(TableComponent.Header.Row, null, React.createElement(TableComponent.Header.Row.ContentCell, null, React.createElement("div", {
    className: "product-odds-label"
  }, React.createElement("div", {
    className: "product-odds-rowheading"
  }, "Totalt antal m\xE5l"))), outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.map(labels => React.createElement(TableComponent.Header.Row.HeaderCell, {
    className: "product-odds-cell-heading",
    key: labels.text
  }, labels.text)))), React.createElement(TableComponent.Body, null, odds.length > 0 && React.createElement(TableComponent.Body.Row, {
    className: "match-info-over-under-odds-row"
  }, React.createElement(TableComponent.Body.Row.HeaderCell, null, React.createElement("div", {
    className: "product-odds-label"
  }, React.createElement("div", {
    className: "product-odds-rowheading"
  }, "\xD6ver/Under 2,5 m\xE5l"))), odds && odds.map((odd, i) => React.createElement(TableComponent.Body.Row.ContentCell, {
    key: i
  }, ' ', formatOdds(odd) || '-', ' ')))));
};
setGlobal('svs.components.sportinfo.matchInfoComponents.OverUnder', OverUnder);

 })(window);